<template lang="html">
  <div class="draft-roster">
    <section class="starters">
      <h4>Starters</h4>

      <div class="positions">
        <div class="position" v-for="(position, i) in roster.starters" :key="i">
          <h5>{{ position.position }}</h5>

          <div class="spots">
            <div class="roster-spot" v-for="n in position.numStarters" :key="n">
              <player-card :player="position.players[n - 1]" />
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="bench">
      <h4>Bench</h4>

      <div class="spots">
        <div class="roster-spot" v-for="player in roster.bench" :key="player.id">
          <player-card :player="player" />
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import PlayerCard from '@/components/PlayerCard';

export default {
  props: {
    roster: Object,
  },

  components: {
    PlayerCard,
  },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
  .draft-roster {
    display: flex;
    flex-direction: column;
  }

  .starters {
    margin-bottom: $gp;
  }

  .spots {
    display: flex;
    flex-wrap: wrap;
  }

  .roster-spot:not(:last-child) {
    margin-right: $gp;
  }

  .positions {
    display: flex;
    flex-wrap: wrap;
  }

  .position {
    display: flex;
    align-items: center;

    h5 {
      margin-right: $gp;
    }
  }

  .bench .spots {
    padding-left: $gp * 2;
  }

  .position:not(:last-child) {
    margin-right: $gp;
  }
</style>
